module.exports = __webpack_public_path__ + "img/7.4546d1ad.png";